import React from 'react';
import {Icon} from 'semantic-ui-react';

const Close = () => {
  return <Icon name="close" style={{color: '#ff847c'}} />;
};

export default Close;
